import React from "react"
import { Alert, List } from "@mantine/core"

import { Icon } from "@/components"

import { useStyles } from "@/components/StepErrorSummary/StepErrorSummary.styles"
import ListHeader from "app/static/frontend/projects-new/list/components/ListHeader"

type Error = {
    key: string
    message: string
}

export const StepErrorSummary = ({ id, errors }: { id: string; errors?: Error[] }) => {
    const { classes } = useStyles({ isSingleError: errors?.length === 1 })

    if (!errors) {
        return null
    }

    return (
        <Alert
            icon={<Icon icon="exclamation-circle" iconFamily="fas" />}
            color="red"
            title={errors.length > 1 ? `The step has ${errors.length} error${errors.length > 1 ? "s" : ""}:` : ""}
        >
            <List id={id}>
                {errors.map((error) => (
                    <List.Item className={classes.summaryItem} key={error.key}>
                        {error.message}
                    </List.Item>
                ))}
            </List>
        </Alert>
    )
}
